import React, { Component } from 'react';
import { connect } from 'react-redux';
import { __ } from 'i18n-for-browser';

import apiCall from '../../components/apiCall';

import AudioGameMaterial from '../../components/elements/AudioGameMaterial';
import GoBackButton from '../../components/elements/GoBackButton';
import QuestionButton from '../../components/elements/QuestionButton';

class EscapeRoute extends Component {
  constructor(props) {
    super(props);
    this.state = {
      items: [],
    };
    this.language = props.schoolClass.LanguageId;
    this.difficulty = props.schoolClass.DifficultyId;
    this.game = props.schoolClass.SchoolClassGames.find(scg => scg.GameId === 4);
  }
  componentWillMount() {
    apiCall(`/escapeRouteItem/${this.language}/${this.difficulty}`, null, 'GET')
      .then((items) => {
        const processedItems = items.map((item) => {
            return {
              ...item,
              Material: item.Audio,
            };
          });
        this.setState({ items: processedItems });
      });

  }
  render() {
    const { items } = this.state;
    const { history, gameState, desktop } = this.props;
    if (gameState.roundData.GameId !== 4 || gameState.roundData.state !== 'PLAYING_GAME') {
      history.goBack();
      return null;
    }
    return (
      <div className={'portal-verdienen classleader-prepare ' + (desktop ? 'portal-home darkBckg' : '')}>
        <div className={'container'}>
          <div className={'title-block'}>
            <GoBackButton history={history} />
            <span>
              <h3>
                <QuestionButton>{this.game.Game.name}</QuestionButton>
              </h3>
              <p>{__('sim_globas_verdienen')}</p>
            </span>
          </div>
          <div className={'list-item-container'}>
            {items.map((item) => {
                return (
                  <span key={item.id}>
                    <AudioGameMaterial item={item} />
                  </span>
                );
            })}
          </div>
        </div>
      </div>
    );
  }
}

export default connect(state => ({
  group: state.group,
  schoolClass: state.schoolClass,
  gameState: state.gameState,
}))(EscapeRoute);



// WEBPACK FOOTER //
// ./src/components/routes/EscapeRoute.js